import { MenuBridgeController } from '@joemasilotti/bridge-components';

export default class extends MenuBridgeController {
  connect() {
    super.connect();
    document.removeEventListener('turbo:morph', this.reconnectAfterMorph);
    document.addEventListener('turbo:morph', this.reconnectAfterMorph);
  }

  disconnect() {
    super.disconnect();
    document.removeEventListener('turbo:morph', this.reconnectAfterMorph);
  }

  // A morph keeps this element, so `connect` does not re-run, but a native
  // `replace` visit creates a new screen that needs the menu button sent again.
  // Drop the old screen's reply callbacks first; the new connect supersedes them.
  reconnectAfterMorph = () => {
    this.removePendingCallbacks();
    this.pendingMessageCallbacks = [];
    this.connect();
  };
}
